<form [formGroup]="remarksFormGroup">

<sdps-modal id='beta-remarks-modal' [sdpsTitle]="title" [size]="'flex--medium'" (close)="resetForm()" aria-label="Remarks Modal">

  <div slot="modal-body">

    <p class="adl-modal__heading">
      <span><strong>Request ID: {{ requestId }}</strong></span>
      <span class="sdps-pull-right"><strong>Account No: {{ accountNumber | accountNumberFormat }}</strong></span>
    </p>

    <div *ngIf="remarksList && remarksList.length > 0" class="adl-textarea remarks-list sdps-m-bottom_small sdps-p-around_small">
      <div *ngFor="let remark of remarksList; let i = index;">
        <strong>{{ remark.createdDate }}, {{remark.createdBy}}: </strong>
        <strong *ngIf="isHiddenFromClient(i)" class="sdps-text-market-red sdps-m-right_xxx-small" [innerHTML]="commonConstants.asterix"></strong>
        <span>{{ remark.remark }}</span>
      </div>
    </div>

    <p class="sdps-m-bottom_large" *ngIf="!isHidden">Asterisk(<strong class="sdps-text-market-red">*</strong>) indicates remark is not visible to the client</p>

    <p class="adl-modal__heading" *ngIf="showActionItems"><strong>Enter Comments:</strong></p>
    <label class="sr-only" for="remarksEnterCommentsInput" *ngIf="showActionItems">Enter comments</label>
    <textarea id="remarksEnterCommentsInput" class="adl-textarea remarks-textarea" type="text" maxlength="1000" formControlName="remarksEnterComments"
              *ngIf="showActionItems" [ngClass]="{'p-disabled':status === getConstant.statusLabel.complete || sharedService.showHistoricalView.value}"
              name="remarksEnterComments" emsCharacterLimit (emsCharacterLimitCheck)="showRemarksCharLimit = $event"
              [charMaxLimit]="commonConstants.charLimitValues.thousandMaxLimit">
    </textarea>

    <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
       *ngIf="showActionItems && (remarksFormGroup.get('remarksEnterComments').value && remarksFormGroup.get('remarksEnterComments').value.length > showRemarksCharLimit)">{{getConstant.characterLimit}}
      <span class="character-limit">{{remarksFormGroup.get('remarksEnterComments').value.length}}/{{commonConstants.charLimitValues.thousandMaxLimit}}</span>
    </p>
   
    <div class="sdps-display-inline-block sdps-m-right_xx-large " *ngIf="!isHidden && showActionItems">
      <p-checkbox inputId="remarksHideFromClient" formControlName="hideFromClient" [ngClass]="{'p-disabled':!remarksFormGroup.get('remarksEnterComments').value || sharedService.showHistoricalView.value}" [disabled]="!remarksFormGroup.get('remarksEnterComments').value"
       label="Do not show this remark to Client" binary="true" [ariaLabel]="'Do not show this remark to Client'"></p-checkbox>
                  <label for="remarksHideFromClient" [ngClass]="{'p-disabled':!remarksFormGroup.get('remarksEnterComments').value || sharedService.showHistoricalView.value}">Do not show this remark to Client</label>
                 
    </div>

    <div class="sdps-display-inline-block p-element" *ngIf="!isHidden && showActionItems">
      <p-checkbox inputId="remarksQaReviewed" formControlName="qaReviewed" [ngClass]="{'p-disabled': isQaReviewedFlag === 'Y' || sharedService.showHistoricalView.value}"
        [disabled]="isQaReviewedFlag === 'Y'" label="QA Reviewed"
        binary="true" [ariaLabel]="'QA Reviewed'"></p-checkbox>
    
      <label for="remarksQaReviewed" [ngClass]="{'p-disabled': isQaReviewedFlag === 'Y' || sharedService.showHistoricalView.value}">QA
        Reviewed</label>
    
    
    </div>
  </div>

  <div slot="modal-footer">
    <button class="buttons" type="reset" (click)="sharedService.closeModal('beta-remarks-modal');resetForm()">Cancel</button>
    <button *ngIf="showActionItems" type="button" class="buttons button-save" (click)="saveComments()"
              [disabled]="(!remarksFormGroup.get('remarksEnterComments').value) && (!remarksFormGroup.get('qaReviewed').value || isQaReviewedFlag === 'Y')">Save</button>
  </div>
</sdps-modal>
</form>
